import esiApi from './esiApi';
import i18n from 'i18next';

export const getDataRequest = async(url, params, config = {}) => {
    if(await checkOnline()) { return await checkOnline()}
    return await esiApi.get(`${url}`, params, config = {})
};
export const postDataRequest = async(url, data, config = {}) => {
    if(await checkOnline()) { return await checkOnline()}
    return await esiApi.post(`${url}`, data, config = {})
};
export const putDataRequest = async(url, data, config = {}) => {
    if(await checkOnline()) { return await checkOnline()}
    return await esiApi.put(`${url}`, data, config = {})
};
export const patchDataRequest = async(url, data, config = {}) => {
    if(await checkOnline()) { return await checkOnline()}
    return await esiApi.patch(`${url}`, data, config = {})
};
export const deleteDataRequest = async(url, data, config = {}) => {
    if(await checkOnline()) { return await checkOnline()}
    return await esiApi.delete(`${url}`, data, config = {})
};

export const checkOnline = async() => {
    let online = navigator.onLine;
    if (online) {
        // message.success(`You're online. Connected to the internet.`)
        return false
    } else {
        return false
        // message.warning("You're offline. Please connect to the internet.");
        return {
            status: 0,
            message: i18n.t("You're offline. Please connect to the internet.")
        }
    }
}